import { Mutation } from 'vuex';
import { IModuleState } from './types';

export const setServiceTargets: Mutation<IModuleState> = (state, payload) => {
  state.serviceTargets.data = payload.data;
  state.serviceTargets.loading = !!payload.loading;
};

